import request from '@/utils/requestnew'
import baseUrl from './baseUrl'
import commonJs from '@/utils/common'

const BASE_URL = baseUrl + ''
//const BASE_URL = baseUrl + '/member'

export default {
 //列表接口
 listweather(params) {
    params = params && commonJs.obj.removeNullKey(params)
    return request({
        //url: BASE_URL + '/list',
        url: 'https://api.asilu.com/weather_v2/',
        method: 'get',    
        dataType: 'jsonp',  // 请求方式为jsonp ，默认不用写
        params
    })
},
}